module.exports = __webpack_public_path__ + "static/media/nodatafound.9b6f3d7b.png";